/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commerical BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2019-09-20 14:16:37
 *
 *******************************************************/
// @flow

import React, { Component } from 'react';
import { Banner } from '@shopify/polaris';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';
import { URL } from 'src/constants/links';
import { showChatbox } from 'src/integrations/chatbox';

type Props = {
  onDismiss: Function,
  emailSupport: string
};

type ComposedProps = Props & WithI18nProps;

class DidYouKnowTurbo extends Component<ComposedProps> {
  state = {};

  openChatBox = () => {
    showChatbox();
  };

  render() {
    const { i18n, onDismiss } = this.props;

    const title = i18n.translate('AdminHTML.Integration.DidYouKnow.titleTurbo');
    const content = i18n.translate('AdminHTML.Integration.DidYouKnow.contentTurbo', {
      link: (
        <a
          href={URL['ManageTemplateGuide']}
          target="_blank"
          className="Polaris-Link"
          rel="noopener noreferrer">
          <span style={{ color: 'rgb(44, 110, 203)' }}>
            {i18n.translate('AdminHTML.Integration.DidYouKnow.contentTurbo_link')}
          </span>
        </a>
      ),
      t: (
        <span style={{ textDecoration: 'underline', cursor: 'pointer' }} onClick={this.openChatBox}>
          {i18n.translate('AdminHTML.Integration.DidYouKnow.contentTurbo_t')}
        </span>
      )
    });

    return (
      <Banner title={title} status="info" onDismiss={onDismiss}>
        <p>{content}</p>
      </Banner>
    );
  }
}

export default withI18n()(DidYouKnowTurbo);
